import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const REFRESH_MUTATION = gql`
  mutation refreshToken(
    $token: String! # The user's refreshToken.
  ) {
    refreshToken(input: { refreshToken: $token }) {
      authToken # The new auth token for the user.
      authTokenExpiration # The expiration time of the new auth token.
      success
    }
  }
`;

export const useRefreshTokenMutation = () => {
  const [refreshToken, { data, loading, error }] = useMutation(
    REFRESH_MUTATION,
    {
      onError: (_error) => {},
    }
  );

  const refreshUserToken = useCallback(
    async (token: string) => {
      try {
        const response = await refreshToken({
          variables: { token },
        });
        return response.data?.refreshToken;
      } catch (err) {
        throw err;
      }
    },
    [refreshToken]
  );

  return {
    refreshUserToken,
    data,
    loading,
    error,
  };
};
